import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ComposableMap, Geographies, Geography, Annotation } from "react-simple-maps";
import { geoCentroid } from "d3-geo";
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { STATE_ABBR } from "./complianceConstants";
import ComplianceScore from "./ComplianceScore"; // Import the ComplianceScore component

const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const USAInteractiveMap = ({ onSiteSelection }) => {
  const visitedStates = useSelector(
    (state) => state.ComplianceReducer.stateList
  );
  const tooltipMap = useSelector(
    (state) => state.ComplianceReducer.tooltipMap
  );
  const [tooltipContent, setTooltipContent] = useState(null);

  const getCursorStyle = (stateName) => {
    const isVisited = visitedStates.includes(stateName);
    return isVisited ? "pointer" : "default";
  };

  const getPressedStyle = (stateName) => {
    const isVisited = visitedStates.includes(stateName);
    return isVisited ? "#FF5722" : "#E0E0E0";
  };

  const handleMouseEnter = (stateName) => {
    if(tooltipMap[stateName]) {
      console.log('1')
      const tooltipData = tooltipMap[stateName];
      const tooltipdata = {
        overallYesPercentage: tooltipData.yes,
        overallNoPercentage: tooltipData.no,
        overallUnknownPercentage: tooltipData.unknown,
        lastUpdate: tooltipData.lastUpdate,
        stateName: stateName,
      }
      setTooltipContent(tooltipdata);
    } else {
      setTooltipContent(null);
    }
  };

  const handleMouseLeave = () => {
    setTooltipContent(null);
  };
  return (
    <div className="map-container">
      <Tooltip id="state-tooltip" className="map-tooltip">
        <ComplianceScore overrideClass='tooltip-chart' headerData={tooltipContent} />
      </Tooltip>
      <ComposableMap projection="geoAlbersUsa" className="geo-parent">
        <Geographies geography={geoUrl}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const isVisited = visitedStates.includes(geo.properties.name);
              const centroid = geoCentroid(geo);
              const stateName = geo.properties.name;
              const abbreviation = STATE_ABBR[stateName];

              return (
                <React.Fragment key={geo.rsmKey}>
                  <Geography
                    geography={geo}
                    data-tooltip-id="state-tooltip"
                    data-tooltip-hidden={!isVisited}
                    onClick={() => {
                      if (isVisited) {
                        onSiteSelection({ name: stateName, abbr: abbreviation });
                      }
                    }}
                    fill={isVisited ? "#4CAF50" : "#E0E0E0"}
                    // fill={isVisited ? tooltipMap[stateName].compliantColor : "#E0E0E0"}
                    stroke="#FFF"
                    style={{
                      default: { outline: "none" },
                      hover: { outline: "none", cursor: getCursorStyle(stateName) },
                      pressed: { fill: getPressedStyle(stateName), outline: "none", cursor: getCursorStyle(stateName) },
                    }}
                    onMouseEnter={() => handleMouseEnter(stateName)}
                    onMouseLeave={handleMouseLeave}
                  />
                  {abbreviation && (
                    <Annotation
                      subject={centroid}
                      dx={0}
                      dy={0}
                      connectorProps={{ stroke: "none" }}
                      data-tooltip-hidden={!isVisited}
                      onClick={() => {
                          if (isVisited) {
                            onSiteSelection({ name: stateName, abbr: abbreviation });
                          }
                        }}
                      data-tooltip-id="state-tooltip"
                      onMouseEnter={() => handleMouseEnter(stateName)}
                      onMouseLeave={handleMouseLeave}
                    >
                      <text
                        x="0"
                        textAnchor="middle"
                        alignmentBaseline="central"
                        fontSize={10}
                        fill="#333"
                        style={{ cursor: getCursorStyle(stateName) }}
                      >
                        {abbreviation}
                      </text>
                    </Annotation>
                  )}
                </React.Fragment>
              );
            })
          }
        </Geographies>
      </ComposableMap>
    </div>
  );
};

export default USAInteractiveMap;

